import React, { useEffect, useRef } from "react";
import { X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const PolicyModal = ({ isOpen, document, onClose }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (isOpen && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && document && (
        <motion.div
          className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={(e) => e.target === e.currentTarget && onClose()}
        >
          <motion.div
            className="bg-white w-full sm:max-w-2xl sm:mx-4 sm:rounded-2xl rounded-t-2xl shadow-2xl flex flex-col max-h-[90vh]"
            initial={{ y: 60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 60, opacity: 0 }}
            transition={{ type: "spring", damping: 28, stiffness: 320 }}
          >
            {/* Header */}
            <div className="flex items-start justify-between px-6 pt-6 pb-4 border-b border-gray-100 shrink-0">
              <div>
                <p className="text-xs font-semibold text-blue-950 uppercase tracking-widest mb-1">
                  Versión {document.version} · Actualizado el {document.lastUpdated}
                </p>
                <h2 className="text-lg font-bold text-gray-900 leading-tight">
                  {document.title}
                </h2>
              </div>
              <button
                onClick={onClose}
                className="ml-4 mt-0.5 shrink-0 text-gray-400 hover:text-gray-700 transition-colors"
                aria-label="Cerrar"
              >
                <X size={22} />
              </button>
            </div>

            {/* Scrollable content */}
            <div
              ref={scrollRef}
              className="overflow-y-auto px-6 py-5 space-y-5 text-sm text-gray-700 leading-relaxed"
            >
              {document.sections.map((section, i) => (
                <div key={i}>
                  <h3 className="font-semibold text-gray-900 mb-1">
                    {section.title}
                  </h3>
                  <p>{section.content}</p>
                </div>
              ))}

              <p className="text-xs text-gray-400 pt-2 border-t border-gray-100">
                Este documento está sujeto a revisión por el área legal de Athletain. Para ejercer tus derechos como titular escríbenos a datos@athletain.com.
              </p>
            </div>

            {/* Footer */}
            <div className="px-6 pb-6 pt-4 border-t border-gray-100 shrink-0">
              <button
                onClick={onClose}
                className="w-full bg-blue-950 hover:bg-blue-900 text-white text-xs font-bold tracking-[0.2em] uppercase py-3.5 rounded-lg transition-colors duration-200"
              >
                Entendido
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PolicyModal;
